import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyChallanList from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        priceBreakup
    }
}) => ({
    priceBreakup
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyChallanList);
